import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { LeaseRenewalSettings, LeaseRenewalSettingsCompanyPortalTypedSettingsWithOverridesDocument } from '~/swagger/settings/Api';

const baseUrl = `${envConfig.service.settings}/company-portal/settings/leaserenewal`;

export class LeaseSettingsRepository extends BaseRestRepository {
  public async getAllLeaseSettings(): Promise<LeaseRenewalSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = baseUrl + '/with-overrides';
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getLeaseSettingsByLevel(level: string, levelId: string): Promise<LeaseRenewalSettings> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateLeaseSettings(payload: LeaseRenewalSettings): Promise<LeaseRenewalSettings> {
    const url = `${baseUrl}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
      }),
    });
    return this.getJsonResponse(response);
  }

  public async updateLeaseSettingsByLevel(level: string, levelId: string, payload: LeaseRenewalSettings): Promise<LeaseRenewalSettings> {
    const url = baseUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
        targets: [{ level, levelId }],
      }),
    });
    return this.getJsonResponse(response);
  }

  public async deleteLeaseSettingsByLevel(level: string, levelId: string): Promise<void> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }
}
